import {
  CenteredFadeInSpinner,
  CenteredMessage,
} from '@tableau/data-catalog-shared';
import * as React from 'react';
import { Query } from 'react-apollo';

import { Messages } from '../../../gen-src/Localize';
import { FlowQuery, FlowQuery_flows, FlowQueryVariables } from '../../../gen-src/queries/FlowQuery';
import { FlowQueryGql } from '../../queries/FlowQueryGql';
import { renderQueryResult } from '../renderQueryResult';
import { createRenderDataWithErrorFunction, renderError, renderNoData } from '../widgets/ErrorMessageWidgets';

export type FlowQueryWrapperProps = {
  readonly flowVizportalUrlId: string;
  readonly children: (result: FlowQuery_flows) => React.ReactNode;
};

export class FlowQueryWrapper extends React.Component<FlowQueryWrapperProps> {

  public render(): React.ReactNode {
    return (
      <Query<FlowQuery, FlowQueryVariables>
        query={FlowQueryGql}
        variables={{ flowVizportalUrlId: this.props.flowVizportalUrlId }}
      >
        {result => renderQueryResult(result, {
          renderLoading: () => <CenteredFadeInSpinner />,
          renderData: this.renderFlowData,
          renderNoData: renderNoData,
          renderDataWithError: createRenderDataWithErrorFunction(this.renderFlowData),
          renderError: renderError,
        })}
      </Query>
    );
  }

  private readonly renderFlowData = (data: FlowQuery): React.ReactNode => {
    const flow = data.flows ? data.flows[0] : null;
    if (flow) {
      return this.props.children(flow);
    } else {
      return <CenteredMessage message={Messages.ErrorItemNotFound()} />;
    }
  }
}
